export const Query = (query) => {
    let res = ``
    Object.entries(query).forEach(
        ([key, value]) => (value !== null && value !== undefined && value !== '') ? res+=`${res.length ? '&' : ''}${key}=${value}` : ''
    );
    return res
}